import request from "@/api/request"
// 数据添加库
export function addJobUserAuth(data) {
  return request({
    method: 'post',
    url: '/jobUser/jobAuthUser/addJobUserAuth',
    data:data
  })
}
